import { Box, ButtonV2, StyleSystemProps, styled } from '@withjoy/joykit';
import { ButtonOverrides } from '@withjoy/joykit/components/ButtonV2/Button.types';
import { pxToRem } from '@withjoy/joykit/theme';

export const PDP_MOBILE_QUICK_ADD_BAR_HEIGTH = pxToRem(100);

export const StyledButton = styled(ButtonV2)``;
export const StyledContainer = styled(Box)``;
export const StyledTitle = styled(Box)``;
export const StyledPrice = styled(Box)``;
export const StyledImgContainer = styled(Box)`
  aspect-ratio: 1;
`;
export const StyledGradient = styled(Box)``;

export const StyledImg = styled(Box).attrs<{ photoUrl?: string }>(({ photoUrl }) => {
  return {
    style: {
      backgroundImage: `url("${photoUrl}")`,
    },
  };
})<{ photoUrl?: string }>`
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-size: contain;
  mix-blend-mode: multiply;
  background-position: center;
  transition: transform 0.25s;
  justify-content: center;
  display: flex;
  transform: scale(1.0001);
  position: absolute;
  top: 0;
`;

const containerStyles: StyleSystemProps = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingX: { _: 6, sm2: 6 },
  paddingTop: { _: 4, sm2: 0 },
  paddingBottom: { _: 6, sm2: 0 },
  backgroundColor: 'white',
  height: { _: PDP_MOBILE_QUICK_ADD_BAR_HEIGTH, sm2: pxToRem(56) },
  width: '100%',
  position: 'relative',
  borderBottom: { _: 'none', sm2: '1px solid #EBEBEB' },
  borderTop: { _: '1px solid #EBEBEB', sm2: 'none' },
};

const textStyles: StyleSystemProps = {
  typographyVariant: { _: 'label2', sm2: 'hed2' },
  fontWeight: 'semibold',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

const imgContainerStyles: StyleSystemProps = {
  display: 'flex',
  height: 8,
  marginRight: { _: 1, sm2: 5 },
  paddingY: { sm2: '2px' },
  position: 'relative',
};

const registryPrimaryButtonStyles: ButtonOverrides = {
  Root: {
    props: {
      color: 'white',
      backgroundColor: 'mono14',
      width: { _: '100%', sm2: 'auto' },
      paddingX: 6,
      _hover: {
        color: 'white',
        backgroundColor: 'mono11',
      },
      _active: {
        color: 'white',
        backgroundColor: 'black',
      },
      _disabled: {
        color: 'mono8',
        backgroundColor: 'mono3',
      },
    },
  },
};

const contentContainerStyles: StyleSystemProps = {
  width: '100%',
  height: '100%',
  display: 'flex',
  overflow: 'auto',
  alignItems: { sm2: 'center' },
  justifyContent: { _: 'center', sm2: 'space-between' },
  flexDirection: { _: 'column', sm2: 'row' },
};

const gradientStyles: StyleSystemProps = {
  position: 'absolute',
  top: '-127px',
  left: 0,
  width: '100%',
  height: pxToRem(126),
  background: 'linear-gradient(0deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%)',
};

export const styles = {
  container: containerStyles,
  contentContainer: contentContainerStyles,
  text: textStyles,
  imgContainer: imgContainerStyles,
  buttonOverrides: registryPrimaryButtonStyles,
  gradient: gradientStyles,
};
